import {
  Button,
  LoadingOverlay,
  Modal,
  Stack,
  Text,
} from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { useLanguage } from "../../../stores/LanguageStore";
import { useProfileStore, useSessionStore } from "../../../stores/UserStore";
import { updateProfile, updateSelf } from "../../../api/UserAPI";
import { IconLinkedin } from "../../../components/Icons/IconLinkedin";
import CompleteProfile from "./CompleteProfile";

const NewUserModal = () => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(null);
  const [source, setSource] = useState(null);

  const options = useMemo(() => {
    return [
      {
        label: lang.new_ui_onboarding.web_search,
        value: "web_search",
        emoji: "👨‍💻",
      },
      {
        label: lang.new_ui_onboarding.linkedin_post,
        value: "linkedin_post",
        isLinkedin: true,
      },
      {
        label: lang.new_ui_onboarding.linkedin_message,
        value: "linkedin_message",
        isLinkedin: true,
      },
      {
        label: lang.new_ui_onboarding.referral,
        value: "referral",
        emoji: "🗣️",
      },
      { label: lang.new_ui_onboarding.email, value: "email", emoji: "📩" },
      {
        label: lang.new_ui_onboarding.trade_show,
        value: "trade_show",
        emoji: "🎪",
      },
      { label: lang.new_ui_onboarding.other, value: "other", emoji: "🤔" },
    ];
  }, [lang.new_ui_onboarding]);

  const handleSource = (value) => {
    setLoading(value);
    updateProfile(null, { source: value })
      .then(() => {
        updateSelf();
        setSource(value);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    let params = new URLSearchParams(location.search);
    let showOnboarding = params.get("show_onboarding");
    if (profile?.show_onboarding || showOnboarding) {
      setTimeout(() => {
        setOpened(true);
      }, 1000);
    } else {
      setOpened(false);
    }
  }, [profile?.show_onboarding]);

  return (
    <>
      <Modal
        opened={opened}
        withCloseButton={false}
        overlayProps={{ blur: 2 }}
        size={"md"}
        closeOnClickOutside={false}
        closeOnEscape={false}
      >
        <LoadingOverlay visible={!!loading} />

        {source ? (
          <CompleteProfile onFinish={() => setOpened(false)} inModal />
        ) : (
          <Stack p={"md"} gap={"lg"}>
            <Text ta={"center"} fz={32} mb={-16}>
              🚀
            </Text>
            <Text fz={32} ta={"center"} fw={800} c={"primary"} lh={1.1}>
              {lang.new_ui_onboarding.title}
            </Text>

            <Text size="lg" ta={"center"}>
              {lang.new_ui_onboarding.text} <br />{" "}
              {useSessionStore.getState().reseller?.name} ?
            </Text>

            {options.map((item) => (
              <Button
                key={item.value}
                size="lg"
                variant={source === item.value ? "filled" : "outline"}
                radius={"md"}
                onClick={() => handleSource(item.value)}
                justify="start"
                c={"black"}
                fz={18}
                leftSection={
                  item.isLinkedin ? (
                    <IconLinkedin
                      size={32}
                      style={{ marginLeft: 2, marginRight: 4 }}
                    />
                  ) : (
                    <Text fz={28}> {item.emoji} </Text>
                  )
                }
              >
                {item.label}
              </Button>
            ))}
          </Stack>
        )}
      </Modal>
    </>
  );
};

export default NewUserModal;
